import { CalendarEvent } from '../types/todo';
import { supabase } from '../lib/supabaseClient';

const API_BASE = process.env.REACT_APP_API_URL ?? '';

async function getAuthHeaders(): Promise<Record<string, string>> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Not authenticated');
  return { Authorization: `Bearer ${session.access_token}` };
}

async function apiFetch(path: string, options?: RequestInit): Promise<any> {
  const authHeaders = await getAuthHeaders();
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: { ...authHeaders, 'Content-Type': 'application/json', ...options?.headers },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || res.statusText);
  }
  return res.json();
}

export async function fetchGcalStatus(): Promise<{ connected: boolean }> {
  return apiFetch('/api/google/status');
}

export async function fetchGcalAuthUrl(): Promise<{ url: string }> {
  return apiFetch('/api/google/auth-url');
}

export async function fetchGcalEvents(date: string): Promise<{ events: CalendarEvent[] }> {
  return apiFetch(`/api/google/events?date=${encodeURIComponent(date)}`);
}

export async function disconnectGcal(): Promise<void> {
  await apiFetch('/api/google/disconnect', { method: 'POST' });
}

export interface CreateEventPayload {
  date: string;
  title: string;
  startTime: string;
  endTime: string;
}

export async function createGcalEvent(payload: CreateEventPayload): Promise<{ eventId: string }> {
  return apiFetch('/api/google/events', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function deleteGcalEvent(eventId: string): Promise<void> {
  await apiFetch(`/api/google/events/${encodeURIComponent(eventId)}`, { method: 'DELETE' });
}

export async function updateGcalEvent(
  eventId: string,
  patch: Partial<{ title: string; startTime: string; endTime: string }>,
): Promise<void> {
  await apiFetch(`/api/google/events/${encodeURIComponent(eventId)}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
}
